<template>
  <div class="col order-1 order-lg-2">
    <div class="row my-4">
      <div class="col-md-6 offset-md-3 bg-light p-5">
        <h1 class="h4 text-center">{{ 'Log in' | translate }}</h1>
        <div class="mb-3">
          <label for="inputEmail" class="">
            <small>{{ 'Email' | translate }}</small>
          </label>
          <input
            type="email"
            id="inputEmail"
            class="form-control"
            required=""
            autofocus=""
            v-model="email"
          />
          <InputErrors name="email" :errors="errors"></InputErrors>
        </div>
        <div class="mb-3">
          <label for="inputPassword" class="">
            <small>{{ 'Password' | translate }}</small>
          </label>
          <input
            type="password"
            id="inputPassword"
            class="form-control"
            required=""
            v-model="password"
          />
          <InputErrors name="password" :errors="errors"></InputErrors>
        </div>
        <div class="mb-3 my-4 text-center">
          <button class="btn btn-primary" @click.prevent="login">
            {{ 'Sign in' | translate }}
          </button>
        </div>
        <div class="text-center mt-3">
          <small>
            <a href="/password/reset">{{'Forgot Your Password?' | translate}}</a>
          </small>
        </div>
        <div class="text-center mt-3">
          <small>
            {{ 'No account yet?' | translate }}
            <router-link
              v-if="!isAuthenticated"
              :to="`/${$route.params.course}/watch/register`"
            >
              {{ 'Sign up now' | translate }}
            </router-link>
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputErrors from './../components/InputErrors'

export default {
  components: {
    InputErrors,
  },
  data() {
    return {
      email: null,
      password: null,
      errors: [],
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    firstLecture() {
      return this.$store.state.course.sections[0].lectures[0]
    },
  },
  methods: {
    async login() {
      this.errors = []
      try {
        const response = await this.$api.login({
          email: this.email,
          password: this.password,
        })
        this.$store.commit('login', response.data)
        this.$store.dispatch('fetchCourse', this.$route.params.course)
        .then(data => {
          if (data.course.type === 'live') {
            return this.$router.push({
              name: 'live',
              params: {
                course: this.$route.params.course
              },
            })
          }
          this.$router.push({
            name: 'lecture',
            params: {
              course: this.$route.params.course,
              lecture: localStorage.getItem(this.$route.params.course) || this.firstLecture.id,
            },
          })
        })

      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors
        }
      }
    },
  },
}
</script>
